export const addLogo = () => {
    const jobTiles = document.querySelectorAll(".attrax-vacancy-tile");

    if (!jobTiles) {
        return;
    }

    jobTiles.forEach((jobTile) => {
        if (jobTile.closest(".custom-jobs-widget")) {
            return;
        }
        
        let logoWrapper = document.createElement("div");
        logoWrapper.classList.add("attrax-vacancy-tile__logo-wrapper");
        jobTile.prepend(logoWrapper);
    });
};

export const logoReplacer = () => {
    const jobOptionClass: string = ".attrax-vacancy-tile__option-department--";

    //the options given should be the same name give to logos placed in the logo folder including the file extension
    const optionArray: Array<{ name: string; filetype: string }> = [
        { name: "business-group", filetype: ".webp" },
        { name: "consumer-group", filetype: ".webp" },
        { name: "communications", filetype: ".webp" },
        { name: "executive", filetype: ".webp" },
        { name: "finance", filetype: ".webp" },
        { name: "finance-strategy-and-technology", filetype: ".webp" },
        { name: "hr-legal-and-corporate-services", filetype: ".webp" },
        { name: "human-resources", filetype: ".webp" },
        { name: "legal", filetype: ".webp" },
        { name: "operations", filetype: ".webp" },
    ];

    optionArray.forEach((option) => {
        const className = jobOptionClass + option.name;

        if (document.getElementsByClassName(className)) {
            const filePath = `url("/Blob/images/logos/${option.name}${option.filetype}")`;

            const foundClass: Element[] = Array.from(
                document.querySelectorAll(className)
            );

            foundClass.forEach((option) => {
                const parentTile: HTMLElement | null = option.closest(
                    ".attrax-vacancy-tile"
                );

                if (!parentTile) return;

                const logowrapper: HTMLElement | null =
                    parentTile.querySelector(
                        ".attrax-vacancy-tile__logo-wrapper"
                    );

                if (!logowrapper) return;

                logowrapper.style.backgroundImage = filePath;
            });
        }
    });
};

export const brandClassAssignment = () => {
    const brandtiles = document.querySelectorAll(
        ".attrax-vacancy-tile__option-department"
    );

    if (!brandtiles) {
        return;
    }

    brandtiles.forEach((brandtile) => {
        const brandclass = [...brandtile.classList].find((el) =>
            el.includes("attrax-vacancy-tile__option-department--")
        );

        if (!brandclass) {
            return;
        }

        const closestTile = brandtile.closest(".attrax-vacancy-tile");
        if (closestTile) {
            closestTile.classList.add(brandclass);
        }
    });
};

export const setActive = () => {
    const jobtiles = document.querySelectorAll(".attrax-vacancy-tile");

    if (!jobtiles) {
        return;
    }

    jobtiles.forEach((jobtile) => {
        jobtile.classList.add("attrax-vacancy-tile--active");
    });
};
